;(function (angular) {
   'use strict'

   angular.module('azure.filters').filter('dollars', dollarsFilter)

   function dollarsFilter($filter) {
      return function (value, doNotStripZeroCents, fractionSize) {
         // eslint-disable-next-line eqeqeq
         if (value == null) {
            return value
         }

         const filteredValue = $filter('currency')(value, '$', fractionSize)
         return doNotStripZeroCents ? filteredValue : filteredValue.replace('.00', '')
      }
   }
})(angular)
